// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class ShortenUrlService {
   $http: any
   $q: any
   $log: any
   shortenedRegexTest: any
   shortenedUrls: any
   static initClass() {
  
      this.prototype.shortenedRegexTest = /(^https?:\/\/(www\.)?tinyurl\.com)|(^https:\/\/exlibris\.link)/
   }

   constructor($http: any, $q: any) {
      this.getShorten = this.getShorten.bind(this)
      this.$http = $http
      this.$q = $q
      this.shortenedUrls = {}
   }

   getShorten(bookmark: any, url: any) {
      if (!this.shortenedRegexTest.test(bookmark)) {
         if (this.shortenedUrls.hasOwnProperty(bookmark)) {
            return this.$q((resolve: any) => resolve(this.shortenedUrls[bookmark]))
         } else {
            return this.$http.post('/short_url', bookmark)
            .then((result: any) => {
               if (result.status == 200) {
                  return this.shortenedUrls[bookmark] = result.data
               } else {                  
                  return url
               }         
            }).catch((err: any) => {
               this.$log.error(err)
            })
         }
      } else {
         return this.$q((resolve: any) => resolve(bookmark))
      }
   }
}
ShortenUrlService.initClass()

ShortenUrlService.$inject = ['$http', '$q']

angular.module('summonApp.services')
   .service('shortenUrlService', ShortenUrlService)
